const scoutDiscovery = [

    /*{
        "name": "White Lion's Collection",
        "Monster": "White Lion",
        "rules": "Gain the **White Lion Tablet** scount gear.",
    },*/

    {
        "name": "White Lion's Collection",
        "Monster": "White Lion",
        "rules": "Gain the **White Lion Tablet** scount gear.",
    },
    {
        "name": "King's Last Meal",
    },
    {
        "name": "Crystal Firepit",
    },
    {
        "name": "Rock Eater",
    },
    {
        "name": "Nest of Beards",
    },
    {
        "name": "Staircase of Blood",
    },
    {
        "name": "Lamplighter",
    },
    
];


export default scoutDiscovery;